import { render } from "./Vega.vue?vue&type=template&id=4269f883"
import script from "./Vega.vue?vue&type=script&lang=js"
export * from "./Vega.vue?vue&type=script&lang=js"

import "./Vega.vue?vue&type=style&index=0&id=4269f883&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__